import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { smallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { css } from "styled-components";

smallHeadingAndTextStyles.heading = {
    variant: "legend",
    css: css`
        margin: 0 !important;
    `,
}

smallHeadingAndTextStyles.text = {
    css: css`
            width: 100%;
            ${wrapInContainerStyles}
            margin: 0 !important;
        `,
}